
























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import InputText from '@/components/input/text.vue';
import clone from '@/utils/clone';

export const DrawerPick = Vue.extend({
    props: {
        list: {
            type: Array,
            default: function () {
                return [];
            },
        },
        root: {
            type: Boolean,
            default: true,
        },
        mt: {
            type: [String, Number],
            default: 0,
        },
    },
});

@Component({
    name: 'drawerPick',
    components: { InputText },
})
export default class extends DrawerPick {
    @Watch('innerList', { immediate: true, deep: true })
    change(val: any) {
        this.$emit('update:list', val);
    }

    innerList: any = clone(this.list);

    get listClone() {
        return this.innerList;
    }

    get uniqueRadioName() {
        return '_' + Math.random().toString(36).substr(2, 9);
    }

    checkBoxChange(index: number) {
        this.innerList[index].selected = !this.innerList[index].selected;
    }
}
